import { isRefundMethodVisible } from '@/returns/pages/TransactionRMAPage/TransactionRMAPageContent/helpers'

export const getCompleteRmaPayload = rmaInfo => {
  const payload = {
    notify_customer: rmaInfo?.orderInfo?.sendCustomerNotification,
    notification_language: rmaInfo?.orderInfo?.notificationLanguage,
  }

  if (isRefundMethodVisible(rmaInfo) && rmaInfo.orderInfo.refundType) {
    payload.refund = { method: rmaInfo.orderInfo.refundType }
  }

  return payload
}
